import React, { useState, useEffect } from 'react';
// import './TopArrowButton.css'; // Import your CSS file for styling (you can name it as you like)
import topArrow from '../Img/scroll to top.png'
const TopArrowButton = () => {
 const [isVisible, setIsVisible] = useState(false);

 // Show the button when the user scrolls down
 useEffect(() => {
  const handleScroll = () => {
   if (window.scrollY > 100) {
    setIsVisible(true);
   } else {
    setIsVisible(false);
   }
  };

  window.addEventListener('scroll', handleScroll);

  return () => {
   window.removeEventListener('scroll', handleScroll);
  };
 }, []);

 // Scroll to the top when the button is clicked
 const scrollToTop = () => {
  window.scrollTo({
   top: 0,
   behavior: 'smooth', // Smooth scrolling
  });
 };

 return (
  <button
   className={`top-arrow ${isVisible ? 'visible' : ''}`}
   onClick={scrollToTop}
  >
   {/* <img src={topArrow} alt="" /> */}
   <i className="fas fa-arrow-up"></i>
  </button>
 );
};

export default TopArrowButton;
